/* eslint-disable react/prop-types */
/* eslint-disable func-names */
// LIBRARY
import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Form, Button, Row, Col, DatePicker } from 'antd';
import { AlphaNumInput, RegexInput } from 'shared_components/pattern_input';
import { fetchPatients } from 'services/lab_request/labRequest';
import { LabRequestContext } from 'context/labRequestContext';

// CUSTOM MODULES
import { axiosLabAPI } from 'services/axios';
import Message from 'shared_components/message';
import {
	// apiUrlPatientByID,
	// apiUrlPatientByName,
	API_GET_METHOD,
} from 'global_config/constant-global';
import { buttonNames, fieldLabels, FIELD_RULES } from './settings';

// CSS
import './search_patient_form.css';

const dateFormat = 'MM-DD-YYYY';

class SearchPatientForm extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			loading: false,
		};

		this.formRef = React.createRef();
	}

	static contextType = LabRequestContext;

	handleSubmit = async () => {
		const { getFieldsValue, setFieldsValue } = this.formRef.current;

		const { patientID, patientName } = getFieldsValue();

		// Refined Trimming Logic:
		// 1. Remove any spaces after commas (e.g., ", john" -> ",john" or "doe, john" -> "doe,john")
		let cleanedPatientName = patientName ? patientName.replace(/,\s+/g, ',') : '';
		cleanedPatientName = cleanedPatientName.trim();

		if (patientName !== cleanedPatientName) {
			setFieldsValue({ patientName: cleanedPatientName });
		}

		const { populatePatients, storeSearchedVal } = this.props;
		let patients = [];

		this.setState({ loading: true });
		patients = await fetchPatients(cleanedPatientName, patientID);

		console.log('Fetched patients: =>', patients);

		this.setState({ loading: false });

		populatePatients(patients);
		this.context.resetCurrentPage();

		storeSearchedVal(patientID, cleanedPatientName);

		// if (patients.length <= 0) Message.info('No results found');
	};


	clearInputs = async () => {
		const { populatePatients } = this.props;
		const { setFieldsValue } = this.formRef.current;

		setFieldsValue({ patientID: '', patientName: '' });

		populatePatients([]);
	};

	handleFocusID = () => {
		const { setFieldsValue } = this.formRef.current;

		setFieldsValue({ patientName: '' });
	};

	handleFocusName = () => {
		const { setFieldsValue } = this.formRef.current;

		setFieldsValue({ patientID: '' });
	};

	render() {
		const { enableRequestDate } = this.props;
		const { loading } = this.state;

		return (
			<Form
				className="search-patient-form"
				onFinish={this.handleSubmit}
				ref={this.formRef}
				layout="vertical"
			>
				<div className="container">
					{/* Patient id field */}
					<Col className="search-id">
						<Form.Item name="patientID" label={fieldLabels.patientID} rules={FIELD_RULES.patientId}>
							<AlphaNumInput onFocus={this.handleFocusID} maxLength={20} />
						</Form.Item>
					</Col>
					{/* Or */}
					<p className="font-md leading-none text">OR</p>
					{/* Patient Name */}
					<Col className="search-name">
						<Form.Item
							name="patientName"
							validateTrigger="onBlur"
							label={fieldLabels.patientName}
							rules={FIELD_RULES.patientName}
						>
							<RegexInput
								// autoFocus
								regex={/[A-Za-z0-9, -]/}
								maxLength={100}
								onFocus={this.handleFocusName}
								placeholder="LASTNAME,FIRSTNAME"
							/>
						</Form.Item>
					</Col>
					{/* Request date */}
					{enableRequestDate === true ? (
						<Col xs={24} sm={24} md={6} lg={4} style={{ marginTop: 18 }}>
							<Form.Item label={fieldLabels.requestDate}>
								<DatePicker defaultValue={moment()} format={dateFormat} style={{ width: '100%' }} />
							</Form.Item>
						</Col>
					) : null}
					{/* Buttons */}
					<Col>
						<Form.Item shouldUpdate>
							{({ getFieldsValue }) => {
								const { patientID, patientName } = getFieldsValue();
								const disabled = !(patientID || (patientName && patientName.length > 1));

								return (
									<div className="search-buttons">
										<Button shape="round" style={{ width: 120 }} onClick={this.clearInputs}>
											{buttonNames.clear}
										</Button>
										<Button
											shape="round"
											type="primary"
											htmlType="submit"
											disabled={disabled}
											loading={loading}
											style={{ width: 120 }}
										>
											{buttonNames.search}
										</Button>
									</div>
								);
							}}
						</Form.Item>
					</Col>
				</div>
			</Form>
		);
	}
}

SearchPatientForm.propTypes = {
	populatePatients: PropTypes.func.isRequired,
	storeSearchedVal: PropTypes.func,
	enableRequestDate: PropTypes.bool,
};

SearchPatientForm.defaultProps = {
	storeSearchedVal() {
		return null;
	},
	enableRequestDate: true,
};

export default SearchPatientForm;
